/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { OrganisationPipelineConfigSystemDefaultsResponse } from '../types/OrganisationPipelineConfigSystemDefaults'

/**
 * GET /pipeline-stage-defaults
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::systemDefaults
 */
export async function organisationPipelineConfigSystemDefaults(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationPipelineConfigSystemDefaultsResponse>> {
	return axiosInstance.get('/pipeline-stage-defaults', config)
}
